export default {
	name: 'Dropdown',
	props: {
		model: {
			value: Object
		},
		filter: {
			value: Object
		},
		groupID: {
			value: Object
		},
		groups: {
			value: Object
		},
		device: {
			value: Object
		}
	},
	computed: {
		webkitFeaturesEnabled() {
			return this.device.WebkeyVersion >= 565;
		}
	},
	methods: {
		close() {
			this.model.value = false;
		},
		redirectToDevice() {
			this.close();
			this.$emit('redirectToDevice');
		},
		redirectToMap() {
			this.close();
			this.$emit('redirectToMap');
		},
		redirectToTerminal() {
			this.close();
			this.$emit('redirectToTerminal');
		},
		redirectToApps() {
			this.close();
			this.$emit('redirectToApps');
		},
		redirectToFiles() {
			this.close();
			this.$emit('redirectToFiles');
		},
		addDeviceToGroup(groupID) {
			this.close();
			this.$emit('addDeviceToGroup', groupID, [this.model.ID]);
		}
	}
};



// WEBPACK FOOTER //
// ./app/components/dropdown/script.js